import { isEmpty } from 'lodash';

import { MINERVA_API_URL, CLASSTING_AUTH_URL, CT_FIREBASE_AUTH_URL } from '@/config';
import { ctFirebaseAuth } from '@/plugins/firebase';
import { http } from '@/plugins/http';
import types from './mutation-types';

export function setToken({ commit }, token) {
  commit(types.SET_TOKEN, token);

  return Promise.resolve(token);
}

export function setDevice({ commit }, device) {
  commit(types.SET_DEVICE, device);

  return Promise.resolve(device);
}

export function fetchUser({ dispatch }) {
  return http.get(`${MINERVA_API_URL}/users/me`)
    .then(res => (
      dispatch('setUserInStore', res.data)
    ))
    .catch((err) => {
      if (err.response && err.response.status === 404) {
        return dispatch('signIn');
      }

      return Promise.reject(err);
    })
    .catch(err => Promise.reject(err));
}

export function signIn({ dispatch }, accessToken) {
  return http.post(`${MINERVA_API_URL}/users/sign-in`, {})
    .then(res => (
      dispatch('setUserInStore', res.data)
    ))
    .then((userInfo) => {
      // already signed in and is same as previous signed in user
      if (
        ctFirebaseAuth.currentUser
        && ctFirebaseAuth.currentUser.uid === userInfo.id
      ) {
        return true;
      }

      return dispatch('createFirebaseToken', { auth: ctFirebaseAuth, accessToken });
    })
    .catch((err) => {
      dispatch('setToken', '');
      return Promise.reject(err);
    });
}

export function updateUser(_, updateInfo) {
  return http.patch(`${MINERVA_API_URL}/users/me`, updateInfo)
    .catch((err) => {
      // TODO: handle error
      console.error('err while updating user:', err);
      return Promise.reject(err);
    });
}

export function fetchJwt({ dispatch }, { auth, service }) {
  const params = {};
  if (service) {
    params.service = service;
  }
  return http.get(`${CLASSTING_AUTH_URL}/jwt`, { params })
    .then(res => (
      dispatch('firebaseSignin', { auth, jwt: res.data.token })
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching jwt:', err);
      // return Promise.reject(err);
      return err;
    });
}

export function createFirebaseToken({ dispatch }, { auth, accessToken }) {
  return http.post(CT_FIREBASE_AUTH_URL, { access_token: accessToken })
    .then(res => (
      dispatch('firebaseSignin', { auth, jwt: res.data.custom_token })
    ))
    .catch(err => err);
}

export function firebaseSignin(_, { auth, jwt }) {
  return auth.signInWithCustomToken(jwt)
    .catch((err) => {
      // TODO: handle error
      console.info(`err while ${auth.app.options.projectId} firebase login:`, err);
      return Promise.reject(err);
    });
}

export function setUserInStore({ commit }, userInfo) {
  commit(types.SET_USER, userInfo);

  return Promise.resolve(userInfo);
}

export function setUserPropertyInStore({ commit }, setInfo) {
  commit(types.SET_PROPERTY, setInfo);

  return Promise.resolve();
}

export function signOut({ commit }) {
  commit(types.SIGN_OUT);

  return Promise.resolve();
}

export function checkUserToken({ state }) {
  if (!isEmpty(state.token)) {
    return Promise.resolve(state.token);
  }

  return Promise.reject('NO_TOKEN');
}

export function fetchUserLicence({ dispatch }) {
  return http.get(`${MINERVA_API_URL}/users/me/current-user-licence`)
    .then(res => (
      dispatch('setUserLicence', res.data)
    ))
    .catch((err) => {
      if (err.response.status === 404) {
        return false;
      }

      return Promise.reject(err);
    });
}

export function setUserLicence({ commit }, userLicence) {
  commit(types.SET_LICENCE, userLicence);

  return Promise.resolve(userLicence);
}

export function fetchPremiumSchool({ dispatch }) {
  return http.get(`${MINERVA_API_URL}/is-premium-school `)
    .then(res => (
      dispatch('setPremiumSchool', res.data)
    ))
    .catch((err) => {
      if (err.response.status === 404) {
        return false;
      }

      return Promise.reject(err);
    });
}

export function setPremiumSchool({ commit }, premiumSchool) {
  commit(types.SET_PREMIUM_SCHOOL, premiumSchool);

  return Promise.resolve(premiumSchool);
}
